import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Hero.css";

import heroImage1 from "../assets/slide1.png";
import heroImage2 from "../assets/slide9.png";
import heroImage3 from "../assets/slide8.png";
import heroImage4 from "../assets/slide4.png";
import heroImage5 from "../assets/slide2.png";
import heroImage6 from "../assets/slide7.png";
import heroImage7 from "../assets/slide3.png";
import heroImage8 from "../assets/slide6.png";
import heroImage9 from "../assets/slide5.png";

const images = [
  heroImage1, heroImage2, heroImage3,
  heroImage4, heroImage5, heroImage6,
  heroImage7, heroImage8, heroImage9
];

const Hero = () => {
  const navigate = useNavigate();

  const [communities, setCommunities] = useState(0);
  const [lives, setLives] = useState(0);
  const [years, setYears] = useState(0);

  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    // Count-up animation
    let comm = 0, lv = 0, yr = 0;
    const targetComm = 500, targetLives = 1000, targetYears = 5;
    const countInterval = setInterval(() => {
      if (comm < targetComm) comm += 5;
      if (lv < targetLives) lv += 150;
      if (yr < targetYears) yr += 1;

      setCommunities(Math.min(comm, targetComm));
      setLives(Math.min(lv, targetLives));
      setYears(Math.min(yr, targetYears));

      if (comm >= targetComm && lv >= targetLives && yr >= targetYears) clearInterval(countInterval);
    }, 50);

    // Auto-loop images
    const imageInterval = setInterval(() => {
      setActiveIndex(prev => (prev + 1) % images.length);
    }, 3000);

    return () => {
      clearInterval(countInterval);
      clearInterval(imageInterval);
    }
  }, []);

  // Mobile swipe support
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  const handleTouchStart = (e) => setTouchStart(e.targetTouches[0].clientX);
  const handleTouchMove = (e) => setTouchEnd(e.targetTouches[0].clientX);
  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const diff = touchStart - touchEnd;
    if (diff > 50) setActiveIndex(prev => (prev + 1) % images.length);
    else if (diff < -50) setActiveIndex(prev => (prev - 1 + images.length) % images.length);
    setTouchStart(null);
    setTouchEnd(null);
  }

  return (
    <section className="hero-section">
      {/* Left */}
      <div className="hero-left">
        <h1 className="hero-title">
          Empowering <span>Communities</span> Through Education & Welfare
        </h1>
        <p className="hero-subtitle">
          Join us to make a lasting impact. Together, we can change lives and empower futures.
        </p>
        <div className="hero-buttons">
          <button className="btn-primary" onClick={() => navigate("/donate")}>Donate Now</button>
          <button className="btn-secondary" onClick={() => navigate("/about")}>Learn More</button>
        </div>
        <div className="hero-stats">
          <div className="stat">
            <h2>{communities}+</h2>
            <p>Communities Supported</p>
          </div>
          <div className="stat">
            <h2>{lives.toLocaleString()}+</h2>
            <p>Lives Impacted</p>
          </div>
          <div className="stat">
            <h2>{years}+</h2>
            <p>Years of Service</p>
          </div>
        </div>
      </div>

      {/* Right Curved Carousel */}
      <div
        className="hero-right"
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        {images.map((img, idx) => {
          const offset = idx - activeIndex;
          const angle = offset * 15; // arc rotation
          const scale = idx === activeIndex ? 1.2 : 0.9;
          return (
            <img
              key={idx}
              src={img}
              alt={`Hero ${idx + 1}`}
              className="hero-img"
              style={{
                transform: `rotate(${angle}deg) translateY(-${Math.abs(angle) * 2}px) scale(${scale})`,
                zIndex: 10 - Math.abs(offset),
                opacity: Math.abs(offset) > 5 ? 0 : 1
              }}
            />
          );
        })}

        <i className="fas fa-book floating-icon icon1"></i>
        <i className="fas fa-hands-helping floating-icon icon2"></i>
        <i className="fas fa-users floating-icon icon3"></i>
        <i className="fas fa-child floating-icon icon4"></i>
      </div>
    </section>
  );
};

export default Hero;
